import { alpha } from "@mui/material/styles";

const styles = {
    paper: (isMobile) => ({
        width: isMobile ? '100%' : { sm: 440, md: 580 },
        maxWidth: '100vw',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: { xs: 0, sm: '12px 0 0 12px' }, // Rounded corners on desktop
        marginTop: { xs: 0, sm: '20px' }, // Some margin on desktop
        marginBottom: { xs: 0, sm: '20px' },
        maxHeight: { xs: '100vh', sm: 'calc(100vh - 40px)' },
    }),
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: { xs: 2.5, sm: 4 },
        py: { xs: 2, sm: 3 },
        borderBottom: '1px solid',
        borderColor: 'grey.200',
        flexShrink: 0,
        minHeight: { xs: 56, sm: 64 },
    },
    body: {
        px: { xs: 2.5, sm: 4 },
        py: { xs: 2, sm: 2.5 },
        flex: 1,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
            width: '6px',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#9ca3af',
        },
    },
    sectionLabel: {
        fontWeight: 700,
        mb: 1.5,
        fontSize: { xs: '0.875rem', sm: '0.9375rem' },
    },
    platformRow: {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr 1fr', sm: '1fr 1fr 1fr 1fr' },
        gap: { xs: 1, sm: 1.25 },
        mb: 3,
    },
    footer: {
        display: 'flex',
        gap: { xs: 1.5, sm: 2 },
        px: { xs: 2.5, sm: 4 },
        py: { xs: 2, sm: 3 },
        borderTop: '1px solid',
        borderColor: 'grey.200',
        flexShrink: 0,
        pb: { xs: 'calc(16px + env(safe-area-inset-bottom))', sm: 3 },
        backgroundColor: { xs: 'white', sm: 'grey.50' }, // Subtle background on desktop
    },
    createButton: {
        textTransform: 'none',
        borderRadius: 2,
        fontWeight: 700,
        minHeight: { xs: 40, sm: 44 },
        fontSize: { xs: '0.875rem', sm: '1rem' },
        bgcolor: 'primary.main',
        '&:hover': {
            bgcolor: 'primary.dark',
            transform: 'translateY(-1px)',
            boxShadow: 3,
        },
        '&:active': {
            transform: 'translateY(0)',
        },
        '&.Mui-disabled': {
            bgcolor: 'grey.400',
            color: 'white',
        },
        transition: 'all 0.2s ease',
        touchAction: 'manipulation',
    },
    cancelButton: {
        textTransform: 'none',
        borderRadius: 2,
        fontWeight: 700,
        minHeight: { xs: 40, sm: 44 },
        fontSize: { xs: '0.875rem', sm: '1rem' },
        borderColor: 'grey.400',
        color: 'text.secondary',
        '&:hover': {
            borderColor: 'grey.600',
            bgcolor: 'grey.100',
            color: 'black',
        },
        touchAction: 'manipulation',
    },
    platformButtonBase: {
        textTransform: 'none',
        borderRadius: 2,
        border: '2px solid',
        width: { md: 115 },
        px: { xs: 1, sm: 2 },
        py: { xs: 0.75, sm: 1 },
        minHeight: { xs: 40, sm: 44 },
        fontSize: { xs: '0.75rem', sm: '0.875rem' },
        justifyContent: { xs: 'center', sm: 'flex-start' },
        transition: 'all 0.2s ease',
        touchAction: 'manipulation',
    },
    platformButtonSelected: {
        color: '#000000',
        bgcolor: 'rgba(0,0,0,0.04)',
        fontWeight: 600,
        borderColor: '#000000',
    },
    platformButtonUnselected: {
        color: 'text.primary',
        bgcolor: 'transparent',
        fontWeight: 400,
        borderColor: 'transparent',
    },
    platformButtonHover: (isSelected) => ({
        bgcolor: isSelected ? 'rgba(0,0,0,0.08)' : 'rgba(0,0,0,0.04)',
        borderColor: isSelected ? '#000000' : '#bdbdbd',
        transform: 'translateY(-1px)',
    }),
    platformButtonActive: {
        transform: 'translateY(0)',
    },
    platformButton: (isSelected) => ({
        ...styles.platformButtonBase,
        ...(isSelected
            ? styles.platformButtonSelected
            : styles.platformButtonUnselected),
        '&:hover': styles.platformButtonHover(isSelected),
        '&:active': styles.platformButtonActive,
    }),
    platformFeedback: (theme) => ({
        mt: 1.5,
        mb: 2.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 1,
        bgcolor: alpha(theme.palette.success.main, 0.08),
        borderRadius: 1,
        border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
    }),
    platformCheckCircleIcon: {
        color: 'success.main',
        fontSize: { xs: 18, sm: 20 },
    },
    platformSelectedLabel: {
        fontWeight: 500,
        color: 'success.dark',
        fontSize: { xs: '0.8rem', sm: '0.875rem' },
    },
    heading1: {
        fontWeight: 700,
        fontSize: { xs: '1.1rem', sm: '1.25rem' },
    },
    closeIcon: {
        p: { xs: 0.5, sm: 1 },
    },
    bodyHeading1: {
        mb: 1,
        fontSize: { xs: '0.8rem', sm: '0.875rem' },
    },
};

export default styles;
